AFRAME.registerComponent("inspect-pivot-child-selector", {
  schema: {
    selector: { type: "string" }
  }
});
